import { createFileRoute } from '@tanstack/react-router';
import { seo } from '../../utils/seo';

export const Route = createFileRoute('/_layout/review-success')({
  head: () => ({ meta: seo({ title: 'Köszönjük a visszajelzésed!' }) }),
  component: ReviewSuccessRoute
});

function ReviewSuccessRoute() {
  return (
    <div className="container-fluid">
      <div className="page-content centered">
        <h1 className="page-title">Köszönjük a visszajelzésed! 🎉</h1>
        <div></div>
        <div className="coupon">
          Kuponkód: <strong>PWTHX</strong>
        </div>
        <div>
          A kupont a fizetés oldalon tudod beváltani, ha éppen nincs érvényben
          más kedvezmény.
          <br />
          Egyszerre több kedvezmény nem vonható össze.
        </div>
      </div>
    </div>
  );
}
